import socket from './socket';

const getCardPointData = (cardId, headers) =>
  socket.get(`/cards/${cardId}/card-point-data`, undefined, headers);

const upsertCardPointData = (cardId, data, headers) =>
  socket.post(`/cards/${cardId}/card-point-data`, data, headers);

const completeCardPointData = (cardId, taskClosedAt, headers) => {
  // Как dueDate в cards.js: Date через socket нужно слать ISO-строкой,
  // иначе sails.io может потерять значение и на бэке дата станет «сейчас».
  let payloadTaskClosedAt = taskClosedAt;
  if (taskClosedAt instanceof Date) {
    payloadTaskClosedAt = Number.isNaN(taskClosedAt.getTime()) ? null : taskClosedAt.toISOString();
  }

  return socket.post(
    `/cards/${cardId}/card-point-data/complete`,
    { taskClosedAt: payloadTaskClosedAt },
    headers,
  );
};

const uncompleteCardPointData = (cardId, headers) =>
  socket.post(`/cards/${cardId}/card-point-data/uncomplete`, undefined, headers);

export default {
  getCardPointData,
  upsertCardPointData,
  completeCardPointData,
  uncompleteCardPointData,
};

